import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Button, Typography } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import useFetch from '../../services/useFetch';
import AppConfig from '../../../src/config/app-config';
import { UserContext } from '../../app';
import './style.css';

const SSO = () => {
    const router = useHistory();
    const {search} = useLocation();
    const { handleLoginUser } = React.useContext(UserContext);
    const searchParams = React.useMemo(() => new URLSearchParams(search), [search]);
    const [firmId, setFirmId] = React.useState('');
    const [ssoSecuredData, setSSOSecuredData] = React.useState('');
    const [showErrors, setShowErrors] = React.useState(false);
    const [isLoginFailed, setIsLoginFailed] = React.useState(false);

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    React.useEffect(() => {
        const ssoLoginFailedData = searchParams.get('SSOLoginFailedSecured');
        if (ssoLoginFailedData) {
            setIsLoginFailed(true);
        }
        let ssoSecuredData = searchParams.get('SSOLoginSecured');
        if (ssoSecuredData) {
            setIsLoginFailed(false);
            ssoSecuredData = ssoSecuredData.replace(/ /g, '+');
            setSSOSecuredData(ssoSecuredData);
        }
    }, [searchParams]);

    const {
        call: ssoLoginAPICall,
        data: ssoLoginAPIData,
        error: ssoLoginAPIError,
    } = useFetch(
        '/V5.0/DeveloperPortal/AuthenticateSSOUser',
        'POST',
        {},
        {},
        {
           ssoSecuredData: `${ssoSecuredData}`,
        },
        [],
        { callOnMount: false }
    );

    const {
        call: ssoValidateAPICall,
        data: ssoValidateAPIData,
        error: ssoValidateAPIError,
    } = useFetch(
        '/V5.0/DeveloperPortal/ValidateSSOGetDetails',
        'POST',
        {},
        {},
        {
            firmId: firmId,
        },
        [],
        { callOnMount: false }
    );

    React.useEffect(() => {
        if (ssoSecuredData) {
           ssoLoginAPICall();
        }
    }, [ssoSecuredData]);

    const handleSSOLogin = () => {
        setShowErrors(false);
        setIsLoginFailed(false);
        if (firmId) {
            ssoValidateAPICall();
        }
    };

    const handleGoBack = () => {
        router.goBack();
    };

    React.useEffect(() => {
        if (ssoValidateAPIData?.IsSSOEnabled == 1) {
            setShowErrors(false);
            if (ssoValidateAPIData?.IDPURL != null && ssoValidateAPIData?.IDPURL != "" && ssoValidateAPIData?.Guid) {
                const expires = new Date(new Date().setMinutes(new Date().getMinutes() + AppConfig.CookieExpiryInMinutes));
                const domain = '.sureprep.com';
                document.cookie = `DevPortalGuid=${ssoValidateAPIData.Guid}; domain=${domain}; path=/; expires=${expires}`;
                window.location.href = ssoValidateAPIData.IDPURL;
            }
        } else if (ssoValidateAPIData?.IsSSOEnabled == 0 || ssoValidateAPIError) {
            setShowErrors(true);
        }
    }, [ssoValidateAPIData]);

    React.useEffect(() => {
        if (!ssoLoginAPIError && ssoLoginAPIData?.message === "Authorized") {
            handleLoginUser({ ...ssoLoginAPIData, domainId: ssoLoginAPIData?.domainName }).then(() => {
                router.push('/');
            });
        }
        if (ssoLoginAPIError || ssoLoginAPIData?.message === "Unauthorized" || ssoLoginAPIData?.ErrorCode || ssoLoginAPIData?.Message === "An unexpected error occured. Please try again later.") {
            setIsLoginFailed(true);
        }
    }, [ssoLoginAPIData, ssoLoginAPIError]);

    return (
        <div>
            <div className="back-button-container">
                <Button className="back-button" onClick={handleGoBack}>
                    <ArrowBack color="primary" />
                </Button>
            </div>
            <div id="ssoCntrlMain">
                <div id="ssoContent">
                    <div id="loginimage" className="login-Header" />
                    {isLoginFailed ? (
                        <div className="errormessage">
                            Login failed. Try again.
                        </div>
                    ) : null}
                    <div className="ssoCntrlinput">
                        <div className="ico_div domainIco" />
                        <input className="login-input" id="txtDomainName" placeholder="Firm ID" onChange={(e) => setFirmId(e.target.value)} />
                    </div>
                    <div id="lognSSOPnl">
                        <div id="loadgifSSO" className="loader" />
                        <input type="button" id="btnSSOLoginVal" name="btnSSOLogin" className="login-button SSO" value="CONTINUE" onClick={handleSSOLogin} disabled={!firmId} />
                    </div>   
                    {showErrors ? (
                        <div className="valdmessg">
                            Your firm does not use Single Sign-On. Please contact your Firm System Administrator.
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default SSO;
